import { api } from './services/api';
import { combineReducers } from '@reduxjs/toolkit';
import profileSlice from '../store/profileSlice';
import checkoutSlice from '../store/checkoutSlice';

const rootReducer = combineReducers({
    profile: profileSlice,
    checkout: checkoutSlice,
    [api.reducerPath]: api.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
